import { render, staticRenderFns } from "./PerformanceMarketingPaymentModal.vue?vue&type=template&id=a18bd64e"
import script from "./PerformanceMarketingPaymentModal.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports